import Head from 'next/head';
import { Typography } from 'antd';

import Layout from '@layouts/BasicLayout';
import PageBreadcrumb from '@components/PageBreadcrumb';
import { useAppLayout } from '@context/LayoutContext';
import OpenGraphMetaTag from '@components/OpenGraphMeta';

import s from '@components/FooterPages/index.module.less';

const { Title, Text } = Typography;

export default function About() {
  const { isMobile } = useAppLayout();
  const steps = [
    {
      id: '/about',
      path: '/about',
      label: 'Giới thiệu Ampo',
    },
  ];

  return (
    <>
      <Head>
        <OpenGraphMetaTag title="Giới thiệu Ampo" description="Thông tin về Ampo" />
      </Head>
      <Layout title="Ampo | Giới thiệu" pageTitle="Giới thiệu Ampo" showBackButton>
        {!isMobile && <PageBreadcrumb steps={steps} />}
        <div className={s.root}>
          <Title level={2} className={s.title}>
            Giới thiệu Ampo
          </Title>
          <section>
            <Text>
              Chào mừng quý khách đến với Ampo - ứng dụng đặt hàng tiện lợi và thông minh của Công ty chúng tôi. Ampo
              được phát triển để giúp khách hàng chủ động đặt hàng và có thể dễ dàng tìm kiếm thông tin về sản phẩm cũng
              như các chương trình khuyến mãi đang diễn ra.
            </Text>
          </section>
          <section>
            <Text>
              Với Ampo, quý khách có thể thoải mái mua sắm từ nhà và trải nghiệm cảm giác mua sắm tuyệt vời mà không cần
              phải đến cửa hàng. Ampo cung cấp cho khách hàng một giao diện thân thiện, dễ sử dụng và đầy đủ tính năng
              cho phép quý khách tìm kiếm và lựa chọn các sản phẩm yêu thích của mình.
            </Text>
          </section>
          <section>
            <Text>
              Ngoài ra, quý khách có thể dễ dàng tìm thấy các chương trình khuyến mãi đang diễn ra và tận hưởng những ưu
              đãi hấp dẫn. Không chỉ giúp quý khách tiết kiệm thời gian và công sức mà còn giúp quý khách tiết kiệm tiền
              bạc.{' '}
            </Text>
          </section>
          <section>
            <Text>
              Với hơn 10 năm kinh nghiệm trong lĩnh vực công nghệ, công ty Công ty chúng tôi luôn cam kết mang đến cho
              khách hàng những sản phẩm và dịch vụ tốt nhất. Ampo là một trong những sản phẩm tiêu biểu của công ty,
              được phát triển để đáp ứng nhu cầu mua sắm của khách hàng một cách nhanh chóng và tiện lợi nhất.
            </Text>
          </section>
          <section>
            <Text>
              Nếu quý khách đang tìm kiếm một ứng dụng đặt hàng đáng tin cậy và hiệu quả, hãy truy cập ngay vào Ampo và
              trải nghiệm cảm giác mua sắm tuyệt vời ngay từ bây giờ !
            </Text>
          </section>
        </div>
      </Layout>
    </>
  );
}
